import { BACKEND_KEYS } from '../../common/consts/app-keys.const';
import {
  EnhancedWithAuthHttpService,
  HttpFactoryService
} from '../../common/services';

export type RiserCapability = {
  id: string;
  eyebrow: string;
  heading: string;
  body: string;
  chips: string[];
};

/**
 * Everything the Riser page draws. Note that this file describes the shape and
 * holds none of the words: the copy is served from behind the grant check, so
 * an account without one receives nothing and there is nothing about Riser in
 * the bundle for anyone to read out of it.
 */
export type RiserPage = {
  hero: {
    eyebrow: string;
    wordmark: string;
    tagline: string;
    title: string;
    subtitle: string;
    primaryCta: string;
    secondaryCta: string;
  };
  appUrl: string;
  whatTitle: string;
  whatBody: string;
  capabilities: RiserCapability[];
  document: {
    title: string;
    body: string;
    formula: string;
    beforeTitle: string;
    beforeBody: string;
    afterTitle: string;
    afterBody: string;
  };
  formats: { title: string; body: string; reads: string[]; writes: string };
  access: { title: string; body: string; label: string };
  cta: { title: string; body: string; label: string };
  nav: {
    name: string;
    description: string;
    valueProp: string;
    tags: string[];
  };
  /** The version Riser is running, or null if it could not be asked. */
  version: string | null;
};

class RiserService {
  httpService: EnhancedWithAuthHttpService;

  constructor(private httpFactory: HttpFactoryService) {
    this.httpService = httpFactory.createAuthHttpService();
  }

  /**
   * The page, if this account holds the grant. The API answers 404 otherwise,
   * which arrives here as a rejected request and renders as the site's
   * ordinary not-found page. There is deliberately no distinct "you do not
   * have access" state to render, because that would be an announcement.
   */
  async getPage(): Promise<RiserPage | null> {
    const response: RiserPage | void = await this.httpService.get(
      BACKEND_KEYS.RISER_PAGE
    );
    return response ?? null;
  }
}

export const riserService = new RiserService(new HttpFactoryService());
